module.exports = __webpack_public_path__ + "img/vip-2.df9a7e91.png";